
export default {
  'main.title': 'Alcohol Management',
  'menu.webhook': 'Data Push',
  'menu.drivelog': 'Drive Log',
  'menu.attendance': 'Attendance',
  'home.home': 'Home',
  'user.email': 'Email',
  'user.input.keyboard.error': 'Please set the input method of the keyboard to half-width mode',
  'user.email.tip': 'Please enter your email address',
  'user.password': 'Password',
  'user.reg': 'Register',
  'user.reg.success': 'Registration successful',
  'user.reg.fail': 'Registration failed',
  'user.reg.success.description': 'Redirecting to login page shortly',
  'user.regnow': 'Register Now',
  'user.login': 'Login',
  'user.signout': 'Sign Out',
  'user.captcha': 'Captcha',
  'user.signInGoogle': 'Login with Google',
  'user.emailCaptcha': 'Verification Code',
  'user.emailCaptcha.tip': 'Please enter the verification code sent to your email',
  'user.getCaptcha': 'Get Verification Code',
  'user.readAndAgree': 'I have read and agree to',
  'user.UserServiceAgreement': 'User Service Agreement',
  'user.action.delete': 'Delete',
  'user.action.more': 'More Actions',
  'user.action.save': 'Save',
  'user.action.save.success': 'Save successfully',
  'user.action.save.fail': 'Save failed',
  'menu.record': 'Test Records',
  'menu.organization': 'Organization',
  'menu.accident': 'Accidents',
  'menu.training': 'Training',
  'menu.worklog': 'Work Logs',
  'org.my.title': 'My Organization',
  'org.my.tip': 'For medium & large enterprises with multi-level organizational structures. Not needed for small businesses.',
  'org.refresh': 'Refresh',
  'org.name': 'Organization Name',
  'org.id': 'Organization ID',
  'org.invite.code': 'Invite Code',
  'org.create.time': 'Created At',
  'org.copy': 'Copy',
  'org.copy.success': 'Invite code copied',
  'org.copy.fail': 'Copy failed, please copy manually',
  'org.create.title': 'Create Organization',
  'org.create.tip': 'Create a new organization. You will become a member automatically.',
  'org.create.placeholder': 'Enter organization name',
  'org.create.name.required': 'Please enter organization name',
  'org.create.button': 'Create Organization',
  'org.create.success': 'Organization created successfully',
  'org.create.fail': 'Failed to create organization',
  'org.join.title': 'Join Organization',
  'org.join.tip': 'Enter the invite code to join an organization.',
  'org.join.placeholder': 'Enter organization invite code',
  'org.join.code.required': 'Please enter organization invite code',
  'org.join.button': 'Join Organization',
  'org.join.success': 'Joined organization successfully',
  'org.join.fail': 'Failed to join organization',
  'org.admin.count': 'Admins',
  'org.driver.count': 'Drivers',
  'org.action': 'Action',
  'org.invite.admin': 'Invite Admin',
  'org.invite.success': 'Invite code copied. Send it to the admin you want to invite.',
  'org.invite.fail': 'Copy failed. Please copy manually.',
  'org.create.modal.title': 'Create New Organization',
  'org.create.sub.button': 'Add Sub-organization',
  'org.create.sub.modal.title': 'Create Sub-organization under {name}',
  'org.create.sub.placeholder': 'Enter sub-organization name',
  'org.delete.button': 'Delete',
  'org.delete.modal.title': 'Delete Organization',
  'org.delete.confirm.prefix': 'Enter the organization name',
  'org.delete.confirm.suffix': ' to confirm deletion. This action cannot be undone.',
  'org.delete.confirm.placeholder': 'Enter organization name',
  'org.delete.name.not.match': 'Organization name does not match',
  'org.delete.success': 'Organization deleted successfully',
  'org.delete.fail': 'Failed to delete organization',
  'org.rename.button': 'Rename',
  'org.rename.modal.title': 'Rename Organization',
  'org.rename.placeholder': 'Enter a new organization name',
  'org.rename.name.required': 'Please enter an organization name',
  'org.rename.success': 'Organization renamed successfully',
  'org.rename.fail': 'Failed to rename organization',
  'org.add.admin.button': 'Add Admin',
  'org.add.admin.modal.title': 'Add Admin',
  'org.add.admin.tip': 'Create an admin account for this organization directly. The new admin joins this organization automatically.',
  'org.add.admin.account.placeholder': 'Enter email address',
  'org.add.admin.account.required': 'Please enter an email address',
  'org.add.admin.account.format': 'Please enter a valid email address',
  'org.add.admin.passwd.placeholder': 'Enter password (at least 6 characters)',
  'org.add.admin.passwd.min': 'Password must be at least 6 characters',
  'org.add.admin.name.placeholder': 'Enter name (optional)',
  'org.add.admin.success': 'Admin created successfully',
  'org.add.admin.fail': 'Failed to create admin',
  'org.admins.modal.title': 'Manage Admins',
  'org.admins.modal.title.with.org': 'Manage Admins - {name}',
  'org.admins.tip': 'Manage the admins of this organization',
  'org.admins.status': 'Status',
  'org.admins.creator': 'Creator',
  'org.admins.rename': 'Rename',
  'org.admins.reset.pwd': 'Reset Password',
  'org.admins.reset.pwd.modal.title': 'Reset Admin Password',
  'org.admins.reset.pwd.placeholder': 'Enter new password',
  'org.admins.reset.pwd.min': 'Password must be at least 6 characters',
  'org.admins.reset.pwd.success': 'Password reset',
  'org.admins.reset.pwd.fail': 'Failed to reset password',
  'org.admins.rename.modal.title': 'Rename Admin',
  'org.admins.rename.placeholder': 'Enter a new name',
  'org.admins.rename.name.required': 'Please enter a name',
  'org.admins.rename.success': 'Renamed successfully',
  'org.admins.rename.fail': 'Failed to rename',
  'org.admins.delete': 'Delete',
  'org.admins.delete.confirm': 'Are you sure to delete this admin?',
  'org.admins.delete.success': 'Admin deleted',
  'org.admins.delete.fail': 'Failed to delete',
  'org.admins.status.success': 'Status updated',
  'org.admins.status.fail': 'Failed to update status',
  'org.admins.load.fail': 'Failed to load admins',
  'org.drivers.modal.title': 'Driver List',
  'org.drivers.modal.title.with.org': 'Driver List - {name}',
  'org.drivers.bind.time': 'Bound At',
  'org.drivers.load.fail': 'Failed to load drivers',
  'org.drivers.add': 'Add Driver',
  'org.drivers.add.modal.title': 'Add Driver',
  'org.drivers.add.account.placeholder': 'Enter account',
  'org.drivers.add.account.required': 'Please enter account',
  'org.drivers.add.passwd.placeholder': 'Enter password',
  'org.drivers.add.passwd.min': 'Password must be at least 6 characters',
  'org.drivers.add.name.placeholder': 'Enter name',
  'org.drivers.add.success': 'Driver added',
  'org.drivers.add.fail': 'Failed to add driver',
  'org.logs.button': 'Logs',
  'org.logs.modal.title': 'Operation Logs',
  'org.logs.modal.title.with.org': 'Operation Logs - {name}',
  'org.logs.time': 'Time',
  'org.logs.operator': 'Operator',
  'org.logs.action': 'Action',
  'org.logs.target': 'Target',
  'org.logs.detail': 'Detail',
  'org.logs.load.fail': 'Failed to load logs',
  'org.logs.org': 'Organization',
  'org.logs.action.org.create': 'Create Organization',
  'org.logs.action.org.create_sub': 'Create Sub-organization',
  'org.logs.action.org.rename': 'Rename Organization',
  'org.logs.action.org.delete': 'Delete Organization',
  'org.logs.action.admin.create': 'Add Admin',
  'org.logs.action.admin.delete': 'Remove Admin',
  'org.logs.action.admin.rename': 'Rename Admin',
  'org.logs.action.admin.status': 'Toggle Admin Status',
  'org.logs.action.admin.reset.pwd': 'Reset Admin Password',
  'org.logs.action.admin.org.change': 'Change Admin Organization',
  'org.logs.action.driver.create': 'Add Driver',
  'org.logs.action.driver.delete': 'Delete Driver',
  'org.logs.action.driver.rename': 'Rename Driver',
  'org.logs.action.driver.org.change': 'Move Driver to Organization',
  'org.drivers.selected': '{count} selected',
  'org.drivers.delete.confirm': 'Are you sure you want to delete the selected drivers?',
  'org.drivers.delete.success': 'Drivers deleted',
  'org.drivers.delete.fail': 'Failed to delete',
  'org.drivers.rename': 'Rename',
  'org.drivers.rename.modal.title': 'Rename Driver',
  'org.drivers.rename.placeholder': 'Enter new name',
  'org.drivers.rename.name.required': 'Please enter name',
  'org.drivers.rename.success': 'Name updated',
  'org.drivers.rename.fail': 'Failed to update name',
  'org.drivers.change.org': 'Move to Organization',
  'org.drivers.change.org.modal.title': 'Move to Organization',
  'org.drivers.change.org.placeholder': 'Select target organization',
  'org.drivers.change.org.required': 'Please select target organization',
  'org.drivers.change.org.success': 'Moved to target organization',
  'org.drivers.change.org.fail': 'Failed to move',
  'org.drivers.change.org.noAdmin.title': 'No admin in target organization',
  'org.drivers.change.org.noAdmin.content': 'Target organization "{name}" has no admin, so drivers cannot be moved. Please add an admin to this organization first.',
  'org.drivers.change.org.noAdmin.ok': 'Add admin',
  'org.drivers.change.org.noAdmin.cancel': 'Cancel',
  'org.admins.change.org': 'Change Org',
  'org.admins.change.org.modal.title': 'Change Admin Organization',
  'org.admins.change.org.placeholder': 'Select target organization',
  'org.admins.change.org.required': 'Please select a target organization',
  'org.admins.change.org.success': 'Admin organization changed',
  'org.admins.change.org.fail': 'Failed to change',
  'org.join.modal.title': 'Join Organization',
  'org.join.searching': 'Looking up organization...',
  'org.join.org.name': 'Organization: {name}',
  'org.join.not.found': 'No matching organization found',
  'org.empty.tip': 'You have not joined any organization',
  'accident.search.title': 'Accident Search',
  'accident.field.driver': 'Driver',
  'accident.field.name': 'Driver Name',
  'accident.field.type': 'Type',
  'accident.field.time': 'Time',
  'accident.field.location': 'Location',
  'accident.field.summary': 'Summary',
  'accident.field.reason': 'Cause',
  'accident.field.countermeasure': 'Countermeasure',
  'accident.field.action': 'Action',
  'accident.type.1': 'Minor accident',
  'accident.type.2': 'Injury accident',
  'accident.type.3': 'Major accident (2+ deaths)',
  'accident.action.search': 'Search',
  'accident.action.reset': 'Reset',
  'accident.action.create': 'Add Accident',
  'accident.action.export': 'Export Excel',
  'accident.action.edit': 'Edit',
  'accident.action.delete': 'Delete',
  'accident.action.cancel': 'Cancel',
  'accident.modal.create.title': 'Add Accident',
  'accident.modal.edit.title': 'Edit Accident',
  'accident.form.user_id.tip': 'Please select a driver',
  'accident.form.user_id.placeholder': 'Please select a driver',
  'accident.form.type.tip': 'Please select accident type',
  'accident.form.type.placeholder': 'Please select accident type',
  'accident.form.time.tip': 'Please select accident time',
  'accident.form.time.placeholder': 'Please select accident time',
  'accident.form.location.placeholder': 'Please enter the accident location',
  'accident.form.summary.placeholder': 'Please enter the accident summary',
  'accident.form.reason.placeholder': 'Please enter the accident cause',
  'accident.form.countermeasure.placeholder': 'Please enter the countermeasure',
  'accident.message.save.success': 'Saved successfully',
  'accident.message.save.fail': 'Save failed',
  'accident.message.delete.success': 'Deleted successfully',
  'accident.message.delete.fail': 'Delete failed',
  'accident.delete.confirm.title': 'Delete accident record',
  'accident.delete.confirm.content': 'Are you sure you want to delete this accident record?',
  'accident.export.filename': 'Accident List',
  'accident.export.loading': 'Exporting...',
  'accident.export.fail': 'Export failed',
  'training.search.title': 'Training Search',
  'training.field.driver': 'Driver',
  'training.field.name': 'Driver Name',
  'training.field.date': 'Completion Date',
  'training.field.action': 'Action',
  'training.action.search': 'Search',
  'training.action.reset': 'Reset',
  'training.action.create': 'Add Training',
  'training.action.export': 'Export Excel',
  'training.action.edit': 'Edit',
  'training.action.delete': 'Delete',
  'training.action.cancel': 'Cancel',
  'training.modal.create.title': 'Add Training',
  'training.modal.edit.title': 'Edit Training',
  'training.form.user_id.tip': 'Please select a driver',
  'training.form.user_id.placeholder': 'Please select a driver',
  'training.form.date.tip': 'Please select the completion date',
  'training.form.date.placeholder': 'Please select the completion date',
  'training.message.save.success': 'Saved successfully',
  'training.message.save.fail': 'Save failed',
  'training.message.delete.success': 'Deleted successfully',
  'training.message.delete.fail': 'Delete failed',
  'training.delete.confirm.title': 'Delete training record',
  'training.delete.confirm.content': 'Are you sure you want to delete this training record?',
  'training.export.filename': 'Training List',
  'training.export.loading': 'Exporting...',
  'training.export.fail': 'Export failed',
  'training.notice.expired': 'The following drivers have exceeded 1 year and 11 months since their last training completion date. Please arrange training soon:',
  'worklog.search.title': 'Work Log Search',
  'worklog.filter.work_date': 'Work Date',
  'worklog.field.driver': 'Driver',
  'worklog.field.name': 'Driver Name',
  'worklog.field.plate': 'Plate Number',
  'worklog.field.work_start': 'Work Start',
  'worklog.field.work_end': 'Work End',
  'worklog.field.work_location': 'Work Location',
  'worklog.field.rest_time': 'Rest Time',
  'worklog.field.rest_location': 'Rest Location',
  'worklog.field.distance': 'Distance (km)',
  'worklog.field.waypoints': 'Waypoints',
  'worklog.field.action': 'Action',
  'worklog.action.search': 'Search',
  'worklog.action.reset': 'Reset',
  'worklog.action.create': 'Add Work Log',
  'worklog.action.export': 'Export Excel',
  'worklog.action.edit': 'Edit',
  'worklog.action.delete': 'Delete',
  'worklog.action.cancel': 'Cancel',
  'worklog.modal.create.title': 'Add Work Log',
  'worklog.modal.edit.title': 'Edit Work Log',
  'worklog.form.user_id.tip': 'Please select a driver',
  'worklog.form.user_id.placeholder': 'Please select a driver',
  'worklog.form.plate.tip': 'Please enter the plate number',
  'worklog.form.plate.placeholder': 'Please enter the plate number',
  'worklog.form.work_start.tip': 'Please select the work start time',
  'worklog.form.work_start.placeholder': 'Please select the work start time',
  'worklog.form.work_end.tip': 'Please select the work end time',
  'worklog.form.work_end.early': 'Work end time cannot be earlier than work start time',
  'worklog.form.work_end.placeholder': 'Please select the work end time',
  'worklog.form.work_location.placeholder': 'Please enter the work location',
  'worklog.form.rest_time.placeholder': 'e.g. 12:00~13:00 or 1 hour',
  'worklog.form.rest_location.placeholder': 'Please enter the rest location',
  'worklog.form.distance.placeholder': 'Please enter the distance (km)',
  'worklog.form.waypoints.placeholder': 'Please enter waypoints, separated by commas',
  'worklog.message.save.success': 'Saved successfully',
  'worklog.message.save.fail': 'Save failed',
  'worklog.message.delete.success': 'Deleted successfully',
  'worklog.message.delete.fail': 'Delete failed',
  'worklog.delete.confirm.title': 'Delete work log',
  'worklog.delete.confirm.content': 'Are you sure you want to delete this work log?',
  'worklog.export.filename': 'Work Log List',
  'worklog.export.loading': 'Exporting...',
  'worklog.export.fail': 'Export failed',
  'menu.driver': 'Driver Management',
  'menu.title': 'Alcohol Test Management',
  'menu.daily.data': 'Data Daily Report',
  'user.accountSetting': 'Account Settings',
  'user.tip': 'Tip',
  'user.name.change.title': 'Change Name',
  'user.signOutTip': 'Are you sure you want to sign out?',
  'table.emptyText': 'No data available',
  'user.action': 'Action',
  'user.name': 'Name',
  'user.org.name': 'Organization',
  'user.name.tip': 'Please enter your name',
  'user.account': 'Account',
  'user.account.format': 'Account can only contain letters and numbers, at least 5 characters',
  'user.account.min.length': 'Account must be at least 6 characters',
  'user.bindTime': 'Binding Time',
  'user.action.search': 'Search',
  'user.action.bind': 'Bind Driver',
  'user.action.driverCreate': 'Create Driver Account',
  'user.action.driverCreate.success': 'Driver account created successfully',
  'user.action.driverCreate.fail': 'Failed to create driver account',
  'user.action.qrWinOpenTip': 'Do not close this window before the driver completes the QR code scan authorization.',
  'user.action.scanBind': 'Bind Driver via Scanning QR Code',
  'user.action.emailBind': 'Bind Driver via Admin Email Input',
  'user.visit.tip': 'Please invite the driver to scan this QR code in person.',
  'user.action.bind.success': 'Driver binding successful',
  'user.test.id': 'Serial',
  'user.test.value': 'Detection Value (mg/L)',
  'user.test.date': 'Date',
  'user.test.time': 'Time',
  'user.id': 'Driver ID',
  'user.test.appraise': 'Assessment',
  'user.test.user': 'Tester',
  'user.test.image': 'Photo',
  'user.test.appraise.yes': 'Yes',
  'user.test.appraise.no': 'No',
  'user.test.appraise.warn': 'Warn',
  'user.car.license_plate_number': 'License Plate Number',
  'user.action.download': 'Download',
  'user.action.download.tip': 'Please select the records you want to download',
  'user.action.download.success': 'Data download successful',
  'user.action.download.fail': 'Data download failed',
  'user.action.export': 'Export',
  'user.action.export.tip': 'Please select the records you want to export',
  'user.action.export.success': 'Export successful',
  'user.action.export.fail': 'Export failed',
  'user.share.status': 'Share Status',
  'user.share.status.enable': 'Enable',
  'user.share.status.disable': 'Disable',
  'user.share.status.disable.tip': 'The driver has disabled your data viewing permission; they need to enable it within the app for you to view it.',
  'user.action.delete.tip': 'Confirm deletion?',
  'user.action.delete.yes': 'Yes',
  'user.action.delete.no': 'No',
  'user.password.change.password': 'Reset Password',
  'user.password.change.password.tip': 'Please enter your password',
  'user.password.change.passwordReview': 'Confirm Password',
  'user.password.change.password.not.match': 'Passwords do not match',
  'user.action.ok': 'Confirm',
  'user.action.cancel': 'Cancel',
  'user.password.change.ok': 'Save',
  'user.password.change.cancel': 'Cancel',
  'user.password.change.password.current': 'Current Password',
  'user.password.change.password.new': 'New Password',
  'user.password.change.password.new.tip': 'Please enter new password',
  'user.password.change.password.current.tip': 'Please enter current password',
  'user.password.change.passwordReview.new': 'Confirm New Password',
  'user.password.change.passwordReview.new.tip': 'Please re-enter the same new password',
  'user.password.change.password.format.error': 'Password must be a mix of letters and numbers, length 8-20',
  'user.password.level': 'Strength',
  'user.password.level.low': 'Low',
  'user.password.level.medium': 'Medium',
  'user.password.level.high': 'High',
  'user.password.level.error': 'Password strength is insufficient',
  'user.password.level.tip': 'Please enter at least 6 characters. Do not use easily guessable passwords.',
  'user.account.login': 'Login with existing account',
  'user.password.format.tip': 'At least 6 characters, case sensitive',
  'user.password.min.length': 'Password must be at least 6 characters',
  'user.email.captcha.send': 'Verification code sending...',
  'user.email.captcha.send.success': 'Verification code sent successfully, please check your email',
  'user.email.captcha.send.fail': 'Failed to send verification code, please try again',
  'user.email.captcha.required': 'Please get verification code first',
  'user.email.captcha.error': 'Verification code error, please try again',
  'user.password.confirm': 'Confirm Password',
  'user.password.confirm.tip': 'Please enter your password again',
  'user.password.confirm.error': 'Two passwords do not match',
  'user.password.reset': 'Reset Password',
  'user.password.reset.success': 'Password reset successfully',
  'user.password.reset.fail': 'Password reset failed',
  'user.forgetPassword': 'Forgot Password',
  'user.welcome': 'Welcome',
  'user.welcome.back': 'Welcome back',
  'user.agreement.read': 'Please read and agree to the User Privacy Policy',
  'user.profile': 'User Info',
  'user.car.area': 'Region',
  'user.car.type': 'Classification Number',
  'user.car.plateName': 'Plate Name',
  'user.car.number': 'Serial Number',
  'user.car.color': 'Color',
  'user.car.color.GreenWhite': 'White Plate Green Letters',
  'user.car.color.WhiteGreen': 'Green Plate White Letters',
  'user.car.color.BlackYellow': 'Yellow Plate Black Letters',
  'user.car.color.YellowBlack': 'Black Plate Yellow Letters',
  'user.car.color.GreenBlue': 'Blue Plate Green Letters',
  'user.car.color.RedWhite': 'White Plate Red Letters',
  'user.membership.level': 'Membership Level',
  'user.membership.upgrade': 'Upgrade Membership',
  'user.membership.function': 'Function',
  'user.membership.function.location': 'Display Testing Location',
  'user.membership.function.video': 'Video recording',
  'user.membership.function.excel': 'Excel Export',
  'user.membership.function.email': 'Email Alerts',
  'user.membership.function.data.sync': 'data sync',
  'user.membership.pay': 'Pay',
  'user.membership.days': 'Days',
  'user.membership.function.data.limit': 'Data Viewing Permissions',
  'user.membership.expire.time': 'Membership Expiration Time',
  'user.share.code.checking': 'Verifying Authorization Code',
  'user.share.code.params.err': 'Parameter Error',
  'user.share.bind.tip': 'Bind to get data authorization from {name}.',
  'user.share.bind': 'Confirm',
  'user.test.value.limited': 'Upgrade to Pro or Pro+ membership to view test data',
  'user.webhook.function.tip': 'This feature is only intended for users who need to receive and save their own data and have development capabilities. If you are an ordinary user, please ignore this page.',
  'user.webhook.function.tip1': "If you wish to receive the user's test data, two conditions must be met: 1. The target driver must be on your driver list; 2. This feature is a paid service, ensure that you do not have any outstanding payments.",
  'user.webhook.function.tip2': 'When an associated driver performs an alcohol test, the test data will be pushed to the configured URL via HTTPS POST request.',
  'user.webhook.function.tip3': 'The format of the data pushed is in the following application/json format.',
  'user.webhook.remaining.amount': 'Current Remaining Amount:',
  'user.webhook.remaining.amount.tip': 'This service is a paid service, priced at 20 JPY per data entry. To avoid push failures due to insufficient funds, please ensure that your account has sufficient remaining amount.',
  'user.webhook.charge': 'Recharge',
  'user.webhook.amount.unit': 'USD',
  'user.webhook.config.empty': 'There is currently no Webhook URL configured',
  'user.webhook.config': 'Start Configuration',
  'user.webhook.config.update': 'Update Configuration',
  'user.webhook.config.mock': 'Mock Test',
  'user.webhook.config.info': 'Webhook Configuration Information',
  'user.webhook.config.url': 'HTTPS URL',
  'user.webhook.config.tip': 'Example: https://example.com/webhook. Must be an https address.',
  'user.webhook.config.tip2': 'The Webhook URL must start with https://',
  'user.webhook.config.tip3': 'The Webhook URL must be verified before saving. Please refer to the',
  'user.webhook.function.tip6': 'After receiving the data, the developer server needs to return the message_id in the JSON to indicate that the server has correctly received and processed the data. If the developer server does not respond correctly, the ALC Manage server will attempt to resend the data three times. If all attempts fail, the data will be marked as a failed send. If the developer wants to retrieve the failed send record, they can go to the push record tab, find the failed send record, and click the resend button to resend the data.',
  'user.webhook.config.check.doc': 'Webhook URL Verification Documentation',
  'user.webhook.config.tip4': 'Write a simple POST interface and respond correctly.',
  'user.webhook.config.check': 'Verify',
  'user.webhook.config.check.success': 'Verification Passed',
  'user.webhook.config.check.fail': 'Interface verification failed, please check if the interface matches the documentation.',
  'user.webhook.config.unit': 'Data Unit',
  'user.webhook.config.unit.tip': 'Please select the data unit according to regional regulations',
  'user.action.submit': 'Submit',
  'user.action.submit.url.error': 'Unverified HTTPS URL',
  'user.webhook.config.key': 'Security Key',
  'user.webhook.config.key.show': 'Show',
  'user.webhook.config.key.hide': 'Hide',
  'user.webhook.config.key.gen': 'Regenerate',
  'user.webhook.config.enable': 'Enable',
  'user.webhook.config.disable': 'Disable',
  'user.webhook.config.tip5': 'Pushing is currently disabled. Ensure that you have completed the interface development as per the right-side documentation before enabling.',
  'user.webhook.config.mock.sended': 'Mock Data Sent',
  'user.webhook.interface.json.reark': 'Description of fields in the JSON',
  'api.field.key': 'Field',
  'api.field.type': 'Field Value Type',
  'api.field.desc': 'Field Description',
  'user.amount.buy.num.tip': 'Please select the recharge amount',
  'user.amount.charge.custom': 'Custom Amount',
  'user.amount.buy.pay': 'You need to pay:',
  'user.amount.buy.submit': 'Pay with Paypal',
  'user.webhook.tab.config': 'Push Configuration',
  'user.webhook.tab.record': 'Push Record',
  'user.test.location.not.pro': 'To view detailed GPS location, please upgrade your membership to PRO+.',
  'user.password.tip': 'Please enter your login password',
  'user.pay.none': 'No payment required',
  'user.pay.now': 'Pay',
  'sys.error': 'Error',
  'sys.user.info.error': 'User information request failed or login is invalid.',
  'user.test.location': 'Location',
  'user.test.video': 'Video',
  'user.service.support': 'Customer Service Support',
  'user.service.doc': 'Document',
  'user.alc.limited.user': ' Pro member(s) have expired, and the data is not in the Excel spreadsheet.',
  'user.alc.xlsx.download.tip': 'Click to download the daily test data.',
  'user.email.alert': 'Mail Push',
  'user.record.data.syncing': 'During data synchronization, download progress:',
  'user.record.data.sync.finish': 'Data synchronization completed.',
  'user.bind.delete.multiple': 'Batch Delete',
  'user.membership.upgrade.multiple': 'Batch Upgrade',
  'user.membership.expire.alert': '{num} drivers\' PRO membership has expired or is about to expire.',
  'user.membership.limit.none': 'unlimited',
  'user.membership.driver.selected': '{num} drivers have been selected,',
  'user.membership.show.details': 'click to show details.',
  'user.membership.upgradeDetail': 'Member Upgrade Details',
  'user.membership.target.user': 'Name',
  'user.membership.target.level': 'Upgraded membership level',
  'user.membership.target.expireDate': 'Membership expiration date',
  'user.membership.level.pro': 'Pro member',
  'user.membership.level.plus': 'Pro+ member',
  'user.membership.level.trial': 'Trial member',
  'user.membership.switchTo.pro': 'Switch to Pro',
  'user.membership.switchTo.plus': 'Switch to Pro+',
  'user.membership.pay.success': 'Pay success',
  'user.membership.current.trial': 'Current: Trial member.',
  'user.membership.current.pro': 'Current: Pro member, valid until {date}.',
  'user.membership.current.plus': 'Current: Pro+ member, valid until {date}.',
  'user.membership.card.trial': 'Trial Member (Free)',
  'user.membership.card.pro.monthly': 'Pro Member ({price} JPY/month)',
  'user.membership.card.pro.yearly': 'Pro Member ({price} JPY/year)',
  'user.membership.card.plus': 'Pro+ Member ({price} JPY/month)',
  'user.membership.startMonth': 'Start Month:',
  'user.membership.monthUnit': 'month(s)',
  'user.membership.expire.notice': 'Expiration scheduled for {date} (based on actual paid activation period)',
  'user.membership.total': 'Total:',
  'user.membership.currency': 'JPY',
  'user.membership.pricing.desc': 'For detailed explanations of feature differences and pricing, please click ',
  'user.membership.pricing.link': 'here',
  'user.membership.payment.title': 'Membership Payment',
  'user.membership.downgrade.not.support': 'Current Pro+ membership does not support downgrade until expiration.',
   'user.action.delete.title': 'Warning',
  'user.action.delete.content': 'Are you sure to delete the selected driver?',
  'user.attendance.work.dur': 'Work',
  'user.attendance.rest.dur': 'Rest',
  'user.checkin.stat': 'Attendance statistics',
  'user.checkin.record': 'Attendance Record',
  'user.attendance.work': 'work',
  'user.attendance.rest': 'rest',
  'user.checkin.dur': 'Attendance period',
  'user.checkin.date': 'Date',
  'user.checkin.time': 'Time',
  'user.checkin.action': 'Action',
  'user.checkin.location': 'Location',
  'user.checkin.action.clockin': 'Clock in',
  'user.checkin.action.clockout': 'Clock out',
  'user.checkin.action.breakstart': 'Start break',
  'user.checkin.action.breakend': 'End break',
  'user.bind.num': 'Bind {count} people in total',
  'user.alc.test.num': '{count} people have undergone alcohol testing',
  'user.checkin.driver': 'Driver',
  'user.checkin.stat.date': 'Statistical date',
  'user.checkin.stat.month': 'Statistical month',
  'user.checkin.work.dur.real': 'Actual working hours',
  'user.checkin.work.dur': 'Working hours',
  'user.checkin.rest.dur': 'Rest hours',
  'user.checkin.stat.single.day': 'Daily mode',
  'user.checkin.stat.more.day': 'Monthly mode',
  'user.checkin.stat.expire.tip': '{num} people are not included in the statistics due to expired membership. You can open PRO membership for expired members or view their records for free and manually count them.',
'user.drive.log.start': 'Start driving',
  'user.drive.log.end': 'End driving',
  'user.drive.log.time': 'Time',
  'user.drive.log.address': 'Address',
  'user.drive.log.start_address': 'Starting Point Address',
  'user.drive.log.end_address': 'Destination Address'
}
